import type { Contact as ContactModel } from '@/adapters/catalogv1.g';

export function extractContact(model: ContactModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.contact_ref ?? '',
    name: model.name ?? '',
    primaryEmail: model.primary_email?.address,
    primaryPhone: model.primary_phone?.number,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogContact = ReturnType<typeof extractContact>;
